<template>
<div class="chapter">
<div class="inner_page">
<a id="page_x"></a>
<p class="fm01t"><span class="bold">President Samuel Baker</span></p>
<p class="fm01"><span class="bold">and</span></p>
<p class="fm01"><span class="bold">Vice President Daniel Eastman</span></p>
<p class="fm101">were elected to office on</p>
<p class="fm01">November 4, 1984.</p>
<a id="page_xi"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Fm02.vue?2ad629b5